import React, { useRef, useState, useEffect, useMemo } from "react";


import { LS_DIALER_AUTH_NUMBERS_PER_PAGE } from "const/localStorageKeys";
import { MIN_STRING_LENGTH, MAX_STRING_LENGTH } from "const";
import Page from "components/base/Page";
import PageHeader from "components/base/PageHeader";
import styled, { createGlobalStyle } from "styled-components";
import AuthNumbersFilter from "./AuthNumbersFilter";
import AuthNumbersTable from "./AuthNumbersTable";
import { FilterSectionFlexboxGrid, StyledItemFitWidth, StyledItemAutoMargin } from "components/base/FitContainers";
import { withTranslation } from "hoc/WithTranslation";
import m from "definedMessages";
import { resolvePerPage } from "utils";
import { DEFAULT_PER_PAGE_DIALER } from "const";

import { Schema } from "rsuite";

const { StringType } = Schema.Types;

const AuthNumbersPage = ({
    data,
    count,
    loading,
    page,
    perPage,

    getAuthNumbersList,
    formatMessage
}) => {

    const defaultFilterValue = { str: "" };

    const [filter, setFilter] = useState(defaultFilterValue);

    const defaultSort = {
        column: "number", type: "asc"
    };

    const [sort, setSort] = useState(defaultSort);

    const filtersRef = useRef(null);
    const filtersModel = Schema.Model({
        str: StringType()
            .minLength(MIN_STRING_LENGTH, formatMessage(m.minLength, { count: MIN_STRING_LENGTH }))
            .maxLength(MAX_STRING_LENGTH, formatMessage(m.maxLength, { count: MAX_STRING_LENGTH })),
    });

    const resolvedPerPage = useMemo(() => resolvePerPage(
        LS_DIALER_AUTH_NUMBERS_PER_PAGE,
        perPage,
        DEFAULT_PER_PAGE_DIALER
    ), [perPage]);

    useEffect(() => {
        if (filtersRef.current && !filtersRef.current.check()) {
            return;
        }

        getAuthNumbersList(filter, 1, resolvedPerPage, sort);
    }, [filter, getAuthNumbersList, resolvedPerPage, sort]);

    const getItems = (_page, _perPage = resolvedPerPage, sortValue = sort) => {
        getAuthNumbersList(filter, _page, _perPage, sortValue);
    };

    return (<Page>
        <GlobalStyle />
        <PageHeader title={formatMessage(m.noteAllocatedNumbersLink)} showService={false} />

        <FilterSectionFlexboxGrid>
            <StyledItemFitWidth>
                <AuthNumbersFilter
                    filter={filter}
                    filtersRef={filtersRef}
                    filtersModel={filtersModel}

                    setFilter={setFilter}

                    formatMessage={formatMessage}
                />
            </StyledItemFitWidth>
            <StyledItemAutoMargin>
            </StyledItemAutoMargin>
        </FilterSectionFlexboxGrid>


        <AuthNumbersTable
            data={data}
            count={count}
            page={page}
            perPage={perPage}
            loading={loading}

            setSort={setSort}
            getItems={getItems}

            formatMessage={formatMessage}
        />
    </Page>)
};

export default withTranslation(AuthNumbersPage);


const GlobalStyle = createGlobalStyle`
    .rs-picker-check-menu-items {
        overflow-y: hidden !important;
        max-height: none !important;
    }
`;